import { render } from "./FeatureList.vue?vue&type=template&id=4c0fde30&scoped=true"
import script from "./FeatureList.vue?vue&type=script&lang=js"
export * from "./FeatureList.vue?vue&type=script&lang=js"

import "./FeatureList.vue?vue&type=style&index=0&id=4c0fde30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0fde30"]])

export default __exports__